

















import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component({})
export default class BarsGraph extends Vue {
  @Prop({ required: true }) values!: { key: string; value: number }[];

  bars: { key: string; hasValue: boolean; height: string }[] = [];

  @Watch('values', { deep: true })
  updateBars() {
    const maxValue = Math.max(...this.values.map(v => v.value)) || 1;
    const getHeight = (value: number): string => {
      return this.formatPercentage(value / maxValue);
    };

    this.bars = this.values.map(value => ({
      key: value.key,
      hasValue: !!value.value,
      height: getHeight(value.value)
    }));
  }

  private formatPercentage(value: number) {
    return `${value * 100}%`;
  }

  created() {
    this.updateBars();
  }
}
